import { clsx } from 'clsx';

import { OptionalSection } from '@monoimin/ui-core';

import { NavigationItem } from './NavigationItem';
import { PaginationCarousel } from './PaginationCarousel';
import { slideToActiveParams } from './carousel.types';

export interface CarouselDisplayProps {
  title?: string;
  wrapperClassName?: string;
  extraContentTop?: React.ReactNode;
  className?: string;
  containerRef: React.RefObject<HTMLDivElement>;
  handleOnScroll: () => void;
  children: React.ReactNode;
  showNavigation: boolean;
  isClient: boolean;
  slideToPrev: () => void;
  slideToNext: () => void;
  active: number;
  isLast: boolean;
  slideToActive: (param: slideToActiveParams) => void;
  max: number;
}

export const CarouselDisplay = ({
  title,
  wrapperClassName,
  extraContentTop,
  className,
  containerRef,
  handleOnScroll,
  children,
  showNavigation,
  isClient,
  slideToPrev,
  slideToNext,
  active,
  isLast,
  slideToActive,
  max,
}: CarouselDisplayProps) => {
  return (
    <OptionalSection
      heading={title}
      className={clsx('w-full', wrapperClassName)}
    >
      {extraContentTop}
      <div
        className={clsx(
          'md:w-full flex scroll-px-5 px-5 md:px-0 md:scroll-px-0 gap-5 overflow-y-hidden overflow-x-scroll snap-mandatory snap-x scrollbar-hide w-screen',
          className
        )}
        ref={containerRef}
        onScroll={handleOnScroll}
      >
        {children}
      </div>
      {showNavigation && isClient && (
        <div className='slider-nav-container'>
          <NavigationItem onClick={slideToPrev} disabled={active === 0} />
          <PaginationCarousel
            active={active}
            slideToActive={slideToActive}
            max={max}
          />
          <NavigationItem next onClick={slideToNext} disabled={isLast} />
        </div>
      )}
    </OptionalSection>
  );
};
